<template>
  <div class="deskblock">
    <div class="title">
      <h3>平台资源</h3>
      <a @click="getAlotData">更多消息</a>
    </div>

    <Row style="margin-top: 20px">
      <Col class="zixun" span="24" v-for="(item, index) in items" :key="index"
        ><div class="alarmtitle">
          <p>
            <Tag :color="midea[item.type].color">{{
              midea[item.type].name
            }}</Tag
            >{{ item.title }}
          </p>
          <Icon @click="makeCode(item)" type="md-phone-portrait" />
          <a @click="play(item)">{{ midea[item.type].btn }} </a>
        </div>
      </Col>
      <Col span="24" v-show="items.length==0">暂无资源</Col>
    </Row>
    <Modal title="手机扫码查看" width="230" footer-hide v-model="openForm">
      <div id="phoneCode"></div>
    </Modal>
    <Drawer v-if="false" v-model="openForm" width="400">
      <Row style="margin-top: 20px">
        <Col class="zixun" span="24" v-for="(item, index) in alots" :key="index"
          ><div class="alarmtitle">
            <h4>{{ item.title }}</h4>
            <span>下载</span>
          </div>
        </Col>
      </Row>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      midea: {
        0: { name: "视频", color: "#25d37c", btn: "播放" },
        1: { name: "图文", color: "#FFA2D3", btn: "查看" },
        2: { name: "PDF", color: "#eb7881", btn: "查看" },
        3: { name: "word", color: "#34a4f8", btn: "下载" },
        4: { name: "excel", color: "#bd71d5", btn: "下载" },
      },
      searchItem: {
        endTime: 0,
        startTime: 0,
        //isRead: false,
        model: 0, //模式（0-全部，1-发送，2-接收）
        pageNumber: 1,
        pageSize: 4,
        type: 1, //类型（0-其他，1-系统，2-用户，3-流程）
      },
      openForm: false,
      alots: [],

    };
  },
  methods: {
    ///cloud-common-server-msg/remind/list
    getData() {
      var t = this.getUrlKey("t");

      if (t == null) {
        this.items = [
          {
            size: 12,
            title: "平台操作说明书",
            type: 2,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/caozuoshuoming.pdf",
          },
          {
            size: 12,
            title: "运用轨迹分析问题",
            type: 0,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/guijifenxi.mp4",
          },
          {
            title: "角色权限的配置",
            type: 0,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/juesepeizhi.mp4",
          },
          {
            size: 12,
            title: "车辆调度演示",
            type: 0,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/diaodu.mp4",
          },
          {
            title: "司机接单演示",
            type: 0,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/sijijiedan.mp4",
          },
          {
            size: 12,
            title: "平台操作说明书",
            type: 3,
            link: "https://cloud.ly-gps.com/files/ly-cloud/media/来源GPS云计算平台介绍.docx",
          },
        ];
      } else {
        this.items = [];
      }
    },
    getAlotData() {
      this.$Message.info("暂无更多信息");
      return;
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();

      this.searchItem.startTime = new Date(this.yy, 0, 1).getTime();
      this.searchItem.endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
      this.getData();
    },
    play(item) {
      window.open(item.link);
      /* if (item.type == 0) {
        this.openForm = true;
      } else {
        this.$Message.info("待开发");
      } */
    },
    makeCode(item) {
      this.openForm = true;

      var divobj = document.getElementById("phoneCode");
      divobj.innerHTML = "";
      divobj.title = "";
      new QRCode(document.getElementById("phoneCode"), {
        text: item.link,
        //logo:document.getElementById("a333"),
        width: 200,
        height: 200,
        colorDark: "#333",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
  mounted() {
    this.getData();
  },
  //http://localhost:2204/?t=pjck#/workDesk?now=0
};
</script>
<style lang="">
#phoneCode {
  width: 200px;
  height: 200px;
}
.wuliuicon i {
  font-size: 36px;
}
.zixun {
  margin-top: 15px;
}
.zixun .alarmtitle {
  display: flex;
}
.zixun i {
  font-size: 16px;
  color: #5394fe;
  cursor: pointer;
  margin-top: 4px;
}
.zixun a {
  margin-left: auto;
  color: #999;
}
.zixun .nocontent {
  height: 20px;
  overflow: hidden;
}
.zixun .nocontent:hover {
  color: red;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/workDesk/block7.vue